<script>
export default {
    name: 'PageView',
    components: {},
    data() {
        return {
            pageResource: null,
            content: '',
            loading: true
        }
    },
    methods: {
        async getContent(pageId) {
            this.loading = true
            this.pageResource = this.$store.getters.pageResources.find((resource) => resource.id.toLowerCase() == pageId.toLowerCase())
            this.content = await this.pageResource.getContent()
            this.loading = false
            return this.content
        }
    },
    async mounted() {
        await this.getContent(this.$route.params.id)
    },
    async beforeRouteUpdate(from, to, next) {
        this.content = await this.getContent(from.params.id)
        next()
    }
}
</script>

<template>
    <div>
        <header-image src="hero-main5.jpg">
            <h1>{{ this.pageResource }}</h1>
        </header-image>
        <section>
            <b-container v-if="!loading">
                <div v-html="content">
                </div>
            </b-container>
            <b-container v-else>
                <div class="text-center">
                    Cargando...
                </div>
            </b-container>
        </section>       
    </div>
</template>

<style lang="scss">
.header-container {
    padding: 10rem 0;

    h2.hero {
        font-size: 3em;
    }
}

.card-content-sizer {
    height: 188px;
}

#events h4.card-title {
    font-weight: 700;
}
</style>
